import Axios from "axios";

/**
 * Adds an event listener to send the collapsed status of a card
 * to the server to preserve it between reloads
 *
 * @param {Element} [container]
 */
function addRememberCollapsibleHandlerToCards(container) {
	if (!container) {
		container = document.body;
	}


	if (container.classList.contains('card')) {
		// Container is a card, setup directly
		setupCard(container);
	} else {
		// Get all cards on container
		container.querySelectorAll('.card').forEach(card => {
			setupCard(card);
		})
	}

	/**
	 * Methods
	 */

	/**
	 * @param card
	 */
	function setupCard(card) {
		card.querySelectorAll('.card-tools button[data-card-widget="collapse"]')
			.forEach(collapseButton => {
				collapseButton.addEventListener('click', () => {
					// Wait long enough so we are sure animation is finished
					// before checking for card status, also we don't want to tax
					// the poor browser even more during the animation
					setTimeout(() => {
						const cardIsCollapsed = card.querySelector('.card-body')
							.style.display === 'none';

						Axios.post(window['routes/ui-element.preserve-card-status'],
							{
								cardHash: card.dataset.uniqueHash,
								collapsed: cardIsCollapsed,
							}
						)    // Ignore result
							.then()
							.catch()

					}, 1000)
				})
			})
	}
}


export {addRememberCollapsibleHandlerToCards}
